import React, { Component } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@material-ui/core';
import userService from '../../api/userService';

export default class ConfirmDeleteUser extends Component {
    constructor(props) {
        super(props);

        this.deleteUser = this.deleteUser.bind(this);
    }

    deleteUser() {
        const { id } = this.props.user;
        userService.deleteUser(id)
            .then(() => {
                this.props.onClose();
            });
    }

    render() {
        const { showConfirm, onClose, user } = this.props;
        if (user) {
            return (
                <Dialog
                    open={showConfirm}
                    onClose={onClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">Delete this Administrator Account?</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            You are deleting {user.fullName}'s account. He will not be able to connect in the BackOffice if you continue.
                            Do you want to proceed?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={onClose} color="primary">No, go back</Button>
                        <Button onClick={this.deleteUser} color="primary" autoFocus>Yes</Button>
                    </DialogActions>
                </Dialog>
            );
        } else {
            return null;
        }
    }
}